import { FC, useEffect } from "react";
import FinanceContainer from "../../components/containers/FinanceContainer";


const FinancePage: FC = () => {
    return (
        <div className={"main-admin__content"}>
            <div className="main-admin__header">
                <h1 style={{ color: "#ffffff", marginBottom: "20px" }}>Финансы</h1>
            </div>
            <div className="main-admin__filters">
                <div className={"main-admin__buttons"}></div>
                <div className="main-admin__filters-block"></div>
            </div>


            <FinanceContainer />
        </div>
    );
};

export default FinancePage;
